import { render, staticRenderFns } from "./QuestionUpload.vue?vue&type=template&id=0016ee1a&scoped=true&"
import script from "./QuestionUpload.vue?vue&type=script&lang=js&"
export * from "./QuestionUpload.vue?vue&type=script&lang=js&"
import style0 from "./QuestionUpload.vue?vue&type=style&index=0&id=0016ee1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0016ee1a",
  null
  
)

export default component.exports